import gql from "graphql-tag";
import { ChallengeFragment, challengeFragment } from "./challenge";
import { GameFragment, gameFragment } from "./game";

export type MeQuery = {
  me?: {
    id: string;
    name: string;
    email: string;
  };
};

export const meQuery = gql`
  query meQuery {
    me {
      id
      name
      email
    }
  }
`;

export type DashboardQuery = {
  me?: {
    id: string;
    name: string;
    email: string;
    incomingChallenges: {
      nodes: ChallengeFragment[];
    };
    gamesNeedingAction: {
      nodes: GameFragment[];
    };
    gamesWaiting: {
      nodes: GameFragment[];
    };
    finishedGames: {
      nodes: GameFragment[];
    };
  };
};

export const dashboardQuery = gql`
  query dashboardQuery {
    me {
      id
      name
      email

      incomingChallenges(status: pending, first: 10) {
        nodes {
          ...Challenge
        }
      }

      gamesNeedingAction: relatedGames(status: needs_action, first: 9) {
        nodes {
          ...Game
        }
      }

      gamesWaiting: relatedGames(status: waiting, first: 9) {
        nodes {
          ...Game
        }
      }

      finishedGames: relatedGames(status: over, first: 9) {
        nodes {
          ...Game
        }
      }
    }
  }

  ${challengeFragment}
  ${gameFragment}
`;

export type UserQuery = {
  user: {
    id: string;
    name: string;
    email: string;
  };
  me: {
    id: string;
    outgoingChallenges: {
      nodes: ChallengeFragment[];
    };
    incomingChallenges: {
      nodes: ChallengeFragment[];
    };
  };
};

export const userQuery = gql`
  query userQuery($id: ID!) {
    user(id: $id) {
      id
      name
      email
    }

    me {
      id
      outgoingChallenges(recipientId: $id, status: pending, first: 1) {
        nodes {
          ...Challenge
        }
      }
      incomingChallenges(senderId: $id, status: pending, first: 1) {
        nodes {
          ...Challenge
        }
      }
    }
  }

  ${challengeFragment}
`;

export const userSignInWithPassword = gql`
  mutation userSignInWithPassword($email: String!, $password: String!) {
    authResponse: userSignInWithPassword(email: $email, password: $password) {
      token
      expiresAt
      user {
        id
        name
        email
      }
    }
  }
`;

export type UserCreate = {
  authResponse: {
    token: string;
    expiresAt: string;
    user: {
      id: string;
      name: string;
      email: string;
    };
  };
};

export const userCreate = gql`
  mutation userCreate($email: String!, $password: String!, $name: String!) {
    authResponse: userCreate(email: $email, password: $password, name: $name) {
      token
      expiresAt
      user {
        id
        name
        email
      }
    }
  }
`;
